import { useMutation } from '@tanstack/react-query'
import { resendVerification } from '../utils/resendVerification'
import type { ApiError } from '@/types/api'
import { toast } from '@/integrations/toaster-provider'
import { notifyRequestError } from '@/utils/notifyRequestError'

export const useResendVerificationMutation = (onSuccess?: VoidFunction) => {
  return useMutation({
    mutationFn: (email: string) => resendVerification(email),
    onSuccess: () => {
      toast.success('Verification email resent successfully')
      onSuccess?.()
    },
    onError: (error: ApiError) => {
      notifyRequestError(error, 'Failed to send password reset email')
    },
  })
}
